
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gallery-arrow-down': {
    width: 5.8,
    height: 6.7,
    viewBox: '0 0 5.8 6.7',
    data: '<path pid="0" d="M5.6 3.7c-.2-.2-.5-.2-.7 0L3.4 5.2V.5c0-.3-.3-.5-.5-.5s-.5.2-.5.5v4.7L.9 3.7c-.2-.2-.5-.2-.7 0s-.2.5-.1.7l2 2c.2.2.4.3.7.3.2 0 .5-.1.7-.3l2-2c.3-.2.3-.5.1-.7z" _fill="#2e3640"/>'
  }
})
